import { useQuery } from "@tanstack/react-query";

import { useAssetInventoryApi } from "../../../../../../api/ClientFileApiContext";
import { ClientFileQueryKey } from "../../../../../../query/clientFileQueryKeys";

export function useMaintenanceObligations(clientId: string) {
  const clientsApi = useAssetInventoryApi();

  const { data: obligations = [] } = useQuery({
    queryKey: [ClientFileQueryKey.AssetInventoryDependants, clientId],
    queryFn: () => clientsApi.getAssetInventoryDependants({ clientId }),
    select: (data) => data.dependants.filter((dependant) => dependant.isEntitledToMaintenance),
  });

  return { obligations };
}
